import { Panel, PanelBody, PanelHeader } from "@itandi/itandi-bb-ui";
import type React from "react";
import { ProfileSettingPassword } from "~/components/specifics/vendors/settings/profiles/ProfileSettingPassword";
import { ProfileSettingVendorUser } from "~/components/specifics/vendors/settings/profiles/ProfileSettingVendorUser";

export const ProfileSetting: React.FC = () => (
	<Panel>
		<PanelHeader title="プロフィール詳細" />
		<PanelBody>
			<ProfileSettingVendorUser />
			<ProfileSettingPassword />
		</PanelBody>
	</Panel>
);
